import React from 'react';
import './splash.css'
import pic1 from '../assets/pic1.png'
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Splash = () => {

    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/onboarding-page1');
        }, 2000);

        return () => clearTimeout(timer); }, [navigate]);


    return ( 
        <>
        <main className='splash-screen-background'>
            <img className='logo-splash' src={pic1} alt='logo'></img>
        </main>
        </>
     );
}
 
export default Splash;